import "preact/debug"
import "preact/devtools"

import { createHashHistory } from "history"
import { render } from "htm/preact"
import Router, { route } from "preact-router"

import { trackEvent } from "../utils/analytics"
import { DisplayOnce, ModalWrapper, VimeoFrame } from "src/utils/fw";

import { Navbar } from "./components/Navbar"
import { Room } from "./components/Room"

import * as roomSources from "./rooms"
import { isMember, nonMemberUrls } from "./utils"
import "./styles.css"
import diamondBooths from "./rooms/boothsDiamond"
import platinumBooths from "./rooms/boothsPlatinum"
import boothsGold from "./rooms/boothsGold"
import boothsSilver from "./rooms/boothsSilver"
import boothsHall from "./rooms/boothsHall"

const rooms = [
	roomSources.atrium,
	roomSources.auditoriumHall,
	roomSources.breakout,
	roomSources.engagementSessions,
	roomSources.lounge,
	roomSources.roundTables,
	roomSources.sponsorTheatre,
	roomSources.keynotes,
	boothsHall,
	diamondBooths,
	platinumBooths,
	boothsGold,
	boothsSilver,
	{
		background: "https://assets.swoogo.com/uploads/full/1386563-615763db46b1e.jpg",
		links: [
			...(isMember ?
				[{
					display: "none",
					label: "Leaderboard",
					modal: <ModalWrapper>
						<iframe style="width: 30vw; height: 35vh; border: none;" src="https://sponsor-gamification.herokuapp.com/leaderboard?eventId=41082&registrantId=10457086&swoogoAccess=false" />
					</ModalWrapper>
				}] : []
			),
			{
				label: "ISF",
				href: "/isf-speakers",
				width: "8.7%",
				height: "8.7%",
				left: "2.3%",
				top: "69.7%",
			},
			{
				label: "Brian Cox",
				width: "17%",
				height: "46%",
				left: "2.2%",
				top: "20.9%",
				modal: <VimeoFrame
					vidId="621813423?h=75db7307c4&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Max Mckeown",
				width: "14.6%",
				height: "38.7%",
				left: "20.1%",
				top: "25.1%",
				modal: <VimeoFrame
					vidId="621815982?h=2db5093369&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Rachel Botsman",
				gaAction: "",
				width: "13.8%",
				height: "35.2%",
				left: "35.7%",
				top: "27.4%",
				modal: <VimeoFrame
					vidId="621815121?h=009f5bf1d9&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Sadie Creese",
				width: "13.7%",
				height: "34.6%",
				left: "50.3%",
				top: "27.5%",
				modal: <VimeoFrame
					vidId="621815589?h=0d003163e0&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Steve Wozniak",
				width: "14.9%",
				height: "38.9%",
				left: "64.9%",
				top: "24.9%",
				modal: <VimeoFrame
					vidId="629262645?h=8d77d497e3&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Viviane Reding",
				width: "16.9%",
				height: "45.2%",
				left: "80.5%",
				top: "20.8%",
				modal: <VimeoFrame
					vidId="621814231?h=e457c89e16&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Members",
				href: "/member-speakers",
				width: "14.8%",
				height: "10.5%",
				left: "82.2%",
				top: "68.5%",
			},
		],
		name: "speaker-gallery",
		extras: 
		<DisplayOnce id="speakergallery-welcome">
			<ModalWrapper><p style={{ color: "white" }}>Click on a frame to hear from these speakers</p></ModalWrapper>
		</DisplayOnce>
	},
	roomSources.isfSpeakers,
	roomSources.memberSpeakers,
	roomSources.sponsorSpeakers,
	roomSources.auditorium,
	roomSources.explorationZone,
	roomSources.onDemand,
	roomSources.auditorium2
]

const handleNewRoute = ({ previous, url }) => {
	if (!isMember && !nonMemberUrls.test(url)) {
		route("/atrium")
	}
	// JS time works in milliseconds so for a 2h timeout we need:
	// 1000 ms per second * 3600 s per hour * 2 hours
	if (window.lastPageLoad && window.lastPageLoad < new Date() - 1000 * 3600 * 2) {
		window.location = "https://isfcongress.tkeventsregistration.com/2023/sign-in"
		route(previous)
	}
	
	if(typeof bindClick !== "undefined") {
		new Array(...document.getElementsByTagName("a")).map(bindClick)
	}

	window.lastPageLoad = new Date()
	trackEvent({
		eventID: 109323,
		from: previous?.replace(/^\//g, "").replace(/^$/g, "atrium") || null,
		to: url.replace(/^\//g, "").replace(/^$/g, "atrium"),
		type: "Venue Navigation",
		userID: window.dataLayer[0]["Registrant ID"],
	})
}

const member = (l) => {
	const res = l.map(it => {
		let ob = it
		if (!isMember) {
			if (/exhibition-hall(-\w+)*/.test(ob.name)) return ob;

			ob.links = ob.links.map(link => {
				if (nonMemberUrls.test(link.href)) return link;

				let linkProps = link
				linkProps.modal = <ModalWrapper wrapperStyle={{background: "rgb(59, 80, 206)"}}>
				<h1 style={{color: "white"}}>This is an ISF Member only area</h1>
				</ModalWrapper>
				linkProps.modalOverrides = {
					dismissHTML: "X",
					dismissStyle: {
						color: "white",
						"font-size": "20px"
					}
				}
				linkProps.href = undefined

				return linkProps;
			})

		}
		return ob
	})

	return res
}
render(
	<>
		<Navbar />
		<Router history={createHashHistory()} onChange={handleNewRoute}>
			{member(rooms).map(room => <Room {...room} path={room.path || room.name.replace(/ /g, "-").replace(/[^A-z-]/g, "")} />)}
		</Router>
	</>,
	document.getElementById("content"),
)